import useClientContext from "../../context/useClientContext";
import FundAccountingProductIcon from "../common/domain-icons/FundAccountingProductIcon";
import { getBusinessCentralRedirectUrl } from "../../utilities/navigationHelper";
import OpenExternalLinkMenuItem from "../common/OpenExternalLinkMenuItem";

const FundOpsMenuLinkItem = () => {
  const { clientCode, settings } = useClientContext();

  if (!settings.businessCentralSettings) {
    return null;
  }

  const businessCentralUrl = getBusinessCentralRedirectUrl(
    clientCode,
    settings.businessCentralSettings,
    "EAC Fund Accountant"
  );

  return (
    <OpenExternalLinkMenuItem Icon={FundAccountingProductIcon} title="Fund Operations" href={businessCentralUrl} />
  );
};

export default FundOpsMenuLinkItem;
